import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { queryUrls } from 'shared/constants/queryApiUrl-constants';
import { LogoutResponse, TQueryError } from 'shared/types/api.interface';
import { LOCAL_STORAGE } from 'shared/constants/local-storage-constants';

const API_URL = process.env.REACT_APP_API_URL;

export const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem(LOCAL_STORAGE.token);
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError | TQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  // try to get a new token if 401 error
  if (result.error && result.error.status === 401) {
    const refresh = localStorage.getItem(LOCAL_STORAGE.refreshToken);
    const refreshResult = await baseQuery(
      { url: queryUrls.authApi.refresh, method: 'POST', body: { refresh } },
      api,
      null,
    );

    if (refreshResult.data) {
      const data = refreshResult.data as LogoutResponse;
      localStorage.setItem(LOCAL_STORAGE.token, data.access); // store the new token
      result = await baseQuery(args, api, extraOptions); // retry the initial query
    } else {
      localStorage.removeItem(LOCAL_STORAGE.token);
      localStorage.removeItem(LOCAL_STORAGE.refreshToken);
    }
  }

  return result;
};
